// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__kd3Sq","prev":"styles_prev__7NwB_","next":"styles_next__IXYcI"};